export default {
  root: {
    width: '450px',
    fontSize: '10px',
    display: 'flex',
    flexDirection: 'column'
  },
  infoText: { width: '500px' },
  inputRow: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'baseline'
  },
  messageContainer: {
    fontSize: '10px',
    visibility: 'hidden',
    textAlign: 'center',
    color: '#F00'
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: '10px'
  },
  buttonContainer: { marginTop: '12px' },
  messageVisible: {
    visibility: 'visible'
  },
  link: {
    cursor: 'pointer',
    '&:hover': { filter: 'brightness(1.5)' },
    marginLeft: '4px'
  }
};

export const customStyles = {
  textfieldRoot: { width: '370px' }
};
